import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Frontpage from "./Pages/Frontpage";
import Navbar from "./Components/Navbar";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Frontpage />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
